/* import __COLOCATED_TEMPLATE__ from './circuit-design.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import Constants from '../../utils/constants';

import CurrentSourceError from '../current-source-dac/error';
import CurrentSourceSinkError from '../current-source-sink-dac/error';
import FastPrecisionError from '../fast-precision-dac/error';
import MultiplyingError from '../multiplying-dac/error';
import VoltageOutputError from '../voltage-output-dac/error';

const ERROR_CLASSES = {
  'current-source-dac': CurrentSourceError,
  'current-source-sink-dac': CurrentSourceSinkError,
  'fast-precision-dac': FastPrecisionError,
  'multiplying-dac': MultiplyingError,
  'voltage-output-dac': VoltageOutputError,
};

export default class CircuitDesign extends Component {
  @service intl;
  @service validationService;

  get errorClass() {
    return ERROR_CLASSES[this.args.model.signalChainHandler.dac.type.name];
  }

  get topologyHeadingText() {
    return this.intl.t('labels.topology', {
      type: this.intl.t(`labels.parts.${this.args.model.signalChainHandler.dac.type.appName}`),
    });
  }

  get signalChainPanels() {
    return this.args.model.signalChainHandler.currentItems.map((item) => {
      let result = item.clone();
      const svgIdKey = result.config.appName.toUpperCase();

      result.headingText = this.intl.t(`labels.parts.${result.config.appName}`);
      result.tooltip = this.intl.t('labels.select_type', {
        article: this.intl.t(`labels.articles.${result.config.article}`),
        type: this.intl.t(`labels.parts.${result.config.appName}`),
      });

      result.showResistor = item.resistor && item.resistor.isCurrent && item.resistor.isShown;

      if (svgIdKey in Constants.SVG.SIGNAL_CHAIN_TO_SVG_ID_MAP) {
        let svgIds = [];
        const idItem = Constants.SVG.SIGNAL_CHAIN_TO_SVG_ID_MAP[svgIdKey];

        if (idItem.GROUP) svgIds.push(`${idItem.GROUP}${result.config.noHighlightGroup ? '' : '_Highlight'}`);
        if (idItem.NAME) svgIds.push(idItem.NAME);

        result.toggleElementIds = svgIds;
        result.toggleStyleClass = Constants.CLASSES.HIGHLIGHT;
      }

      if (result.config.propertyName in this.validationService.circuitDesignTabErrors) {
        result.errorMessages = this.validationService.circuitDesignTabErrors[result.config.propertyName];
      } else {
        result.errorMessages = [];
      }

      return result;
    });
  }

  @action showChooseSignalChainPartModal(signalChainItemPstId) {
    if (this.args.model.cdpDataHandler.parameterMappingData) {
      this.args.model.modalHandler.show(Constants.MODAL_TYPES.CHOOSE_SIGNAL_CHAIN_PART.value, {
        signalChainItemPstId: signalChainItemPstId,
      });
    } else {
      this.args.model.modalHandler.displayNotification(
        this.intl.t('messages.title', { htmlSafe: 'true' }),
        this.intl.t('messages.error-pst-data'),
      );
    }
  }

  @action handleHoverIn(panel) {
    if (panel.toggleElementIds && panel.toggleStyleClass) {
      panel.toggleElementIds.forEach((identifier) => {
        let styleElement = document.querySelector(`#${identifier}`);
        if (styleElement) {
          styleElement.classList.add(panel.toggleStyleClass);
        }
      });
    }
  }

  @action handleHoverOut(panel) {
    if (panel.toggleElementIds && panel.toggleStyleClass) {
      panel.toggleElementIds.forEach((identifier) => {
        let styleElement = document.querySelector(`#${identifier}`);
        if (styleElement) styleElement.classList.remove(panel.toggleStyleClass);
      });
    }
  }
}
